import { memo } from 'react';
import type { ProductWithFixedRelatedProducts } from '../util/processRelatedProducts';
import LinkBreadcrumbs from '../../core/components/LinkBreadcrumbs';

interface ProductBreadcrumbsProps {
    product: ProductWithFixedRelatedProducts;
    description?: string;
}

export const ProductBreadcrumbs = memo(
    ({ product, description }: ProductBreadcrumbsProps) => {
        const categories = product.categories.map(({ name, id }) => ({
            to: `/categories/${id}`,
            label: name,
        }));

        return (
            <LinkBreadcrumbs
                title={product.name}
                description={description}
                breadcrumbs={[
                    ...categories,
                    {
                        label: product.name,
                        to: `/product/${product.id}`,
                    },
                ]}
            />
        );
    }
);
